module.exports = __webpack_public_path__ + "static/media/d5ru.b817bf58.pdf";